// extracted by mini-css-extract-plugin
module.exports = {"reloginRequired":"styles_reloginRequired__1kRPL","innerContainer":"styles_innerContainer__eQTU3","headline":"styles_headline__3zlcH","buttonsParent":"styles_buttonsParent__LdQNG"};